<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="action-bar clear">
  <div class="left">
    <button
      type="button"
      class="xrx-btn btn-secondary btn medium glyph xgl-close"
      (click)="enableFilter ? disableFilter() : activeModal.dismiss()"></button>
  </div>
  <div class="right">
    <button
      type="button"
      class="xrx-btn btn-secondary btn medium glyph-button"
      [disabled]="currentFolder.type != 'dir' && currentFolder.type != 'lib'"
      (click)="selectDirectoryOrFiles()">
      <span class="xgl-checkmark"></span>
      <span class="btn-label text-medium" xdaTranslate>SDE_OK</span>
    </button>
  </div>
  <div class="middle">
    <span class="title text-x-large" xdaTranslate>SDE_BROWSE</span>
    <span class="title text-x-large">{{ connectorName }}</span>
  </div>
</div>
<div class="modal-body">
  <div class="history">
    @for (item of breadcrumb; track item) {
      <span>{{ item.name }}</span>
    }
  </div>
  @if (!enableFilter) {
    <div class="naviagation">
      <button
        type="button"
        class="xrx-btn btn-secondary btn medium glyph xgl-home"
        [disabled]="loading || !breadcrumb || breadcrumb.length == 0"
        (click)="home()"></button>
      <button
        type="button"
        class="xrx-btn btn-secondary btn medium glyph xgl-navigate_left"
        [disabled]="loading || this.breadcrumb.length == 0"
        (click)="back()"></button>
      <button
        type="button"
        class="xrx-btn btn-secondary btn medium glyph-button text-field read-only">
        <span class="xgl-folder"></span>
        <span
          class="btn-label text-medium"
          [xdaTranslate]="currentFolder.name"></span>
      </button>
      <button
        type="button"
        class="xrx-btn btn-secondary btn medium glyph xgl-funnel"
        [disabled]="loadingAll || (displayItems && displayItems.length <= 1)"
        (click)="toggleFilter()"></button>
    </div>
  }
  @if (enableFilter) {
    <div class="filter">
      <input
        type="text"
        id="filterText"
        name="filterText"
        #filterText
        [placeholder]="filterPlaceholder"
        autofocus
        class="textField medium" />
      <button
        type="button"
        class="xrx-btn btn-secondary btn medium"
        xdaTranslate
        (click)="filterDisplayItems(filterText.value)">
        SDE_FILTER
      </button>
    </div>
  }

  <div class="scroll-content">
    <div>
      <div class="repo-content">
        @if (!loading && displayItems && displayItems.length > 0) {
          @for (item of displayItems; track item) {
            <button
              type="button"
              class="xrx-btn btn-secondary btn medium glyph-button"
              [disabled]="!isItemEnabled(item)"
              (click)="browse(item)">
              <span [ngClass]="item.glyph ? item.glyph : ''"></span>
              <span class="btn-label text-medium">{{ item.name }}</span>
            </button>
          }
        }

        @if (loading) {
          <button
            type="button"
            class="xrx-btn btn-secondary btn medium glyph-button loading">
            <span class="xrx-activity-indicator ai-sm ai-spin"></span>
            <span class="btn-label text-medium" xdaTranslate>SDE_LOADING1</span>
          </button>
        }

        @if (!loading && displayItems && displayItems.length == 0) {
          <button
            class="xrx-btn btn-secondary btn medium loading text-medium"
            xdaTranslate>
            SDE_NO_RESULTS_FOUND
          </button>
        }
      </div>
    </div>
  </div>
</div>
